import React, {useState} from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {Link, useNavigate} from "react-router-dom";
import * as Yup from "yup";
import Logo from "../Assets/logo.png";
import register from "../Api/register";
import Swal from "sweetalert2";
import Copyright_Footer from "../Components/copyrightFooter";
import Model from "../Components/ModelParagraph";
import terms from "../Api/terms";

export default function Register() {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [termsData, setTermsData] = useState(null);

  const initialValues = {
    username: "",
    password: "",
    referralCode: "",
    phoneNumber: "",
    // withdrawPassword: ""
  };

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  const validationSchema = Yup.object().shape({
    username: Yup.string().min(3).required("Please Enter Username!!"),
    password: Yup.string()
      .min(4)
      // .max(12)
      .required("Please Enter Your Password."),
    phoneNumber: Yup.string()
      .min(10)
      .max(11)
      .required("Please Enter Phone Number."),
    // withdrawPassword: Yup.string()
    //   .min(8)
    //   .max(12)
    //   .required("Please Enter Withdraw Password."),
    referralCode: Yup.string().required("Please Enter Your Referral Code."),
  });

  const onSubmit = async (data) => {
    try {
      await register(data);
      navigate("/login");
      Toast.fire({
        icon: 'success',
        title: 'Successfully Register'
      })
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error.message
      })
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const fetchTermInfo = async () => {
    try {
      const response = await terms();
      setTermsData(response.data);
    } catch (error) {
      console.error("API Error:", error.message);
      if (error.response.status === 401 || error.response.status === 500) {
        Toast.fire({
          icon: 'error',
          title: error.response.data.title
        })
        localStorage.clear();
        navigate("/");
      }
      Toast.fire({
        icon: 'error',
        title: error.response.data.message
      })
    }
  };

  const toggleModel = () => {
    fetchTermInfo();
    setShowModel(!showModel);
  };

  return (
    <div className="container mobile-page" id='register'>
      <div className="row d-flex justify-content-center align-items-center flex-column">
        <div className="text-center">
          <img src={Logo} alt="Logo" className='logo' />
        </div>

        <div className="mt-10 col-12 col-xl-12 col-md-8 col-sm-10 text-center text-white">
          <h4 className="fw-bold">Create Your Account</h4>
        </div>

        <div className="mt-2 col-12 col-xl-12 col-md-8 col-sm-10 text-center">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            <Form>
              <div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center light-black">
                <span className='text-pink'>Username</span>
                  <Field
                    autoComplete="off"
                    type="text"
                    name="username"
                    placeholder="Type here"
                    className="light-black text-white"
                  />
              </div>
              <ErrorMessage className="error" name="username" component="span" />

              <div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center light-black">
                <span className='text-pink'>Password</span>
                <Field
                  autoComplete="off"
                  type="password"
                  name="password"
                  placeholder="Type here"
                  className="light-black text-white"
                />
              </div>
              <ErrorMessage className="error" name="password" component="span" />


              <div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center light-black">
                <span className='text-pink text-nowrap'>Phone No.</span>
                <Field
                  autoComplete="off"
                  type="text"
                  name="phoneNumber"
                  placeholder="Type here"
                  className="light-black text-white"
                />
              </div>
              <ErrorMessage className="error" name="phoneNumber" component="span"/>

              {/*<div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center light-black">*/}
              {/*  <span className='text-pink text-nowrap'>Withdraw Password</span>*/}
              {/*  <Field*/}
              {/*    autoComplete="off"*/}
              {/*    type="password"*/}
              {/*    name="withdrawPassword"*/}
              {/*    placeholder="Type here"*/}
              {/*    className="light-black text-white"*/}
              {/*  />*/}
              {/*</div>*/}
              {/*<ErrorMessage className="error" name="withdrawPassword" component="span"/>*/}


              <div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center light-black">
                <span className='text-pink text-nowrap'>Referral Code</span>
                <Field
                  autoComplete="off"
                  type="text"
                  name="referralCode"
                  placeholder="Type here"
                  className="light-black text-white"
                />
              </div>
              <ErrorMessage className="error" name="referralCode" component="span"/>

              <div className="py-1 px-4 my-2  d-flex align-items-center ">
                  <Field
                      type="checkbox"
                      name="agreement"
                      id="agreement"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      className="hidden-checkbox"
                  />
                  <label htmlFor="agreement" className="radio-label">
                  </label>
                <a className="ms-3 text-white" role="button" onClick={toggleModel} style={{fontSize: '15px'}}> I agree to the User (Terms & Conditions)</a>
              </div>

              <div className="col-12 d-flex flex-row justify-content-between mt-4">
                <button className="px-4 py-3 rounded-4 mx-1  pink text-white">
                  <Link className="text-white text-decoration-none" to="/login">Back To Login</Link>
                </button>
                <button className="px-4 py-3 rounded-4 mx-1 deepBlack text-white" disabled={!isChecked}>Create Accounts</button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      {showModel && <Model onClose={toggleModel} title={"Terms & Conditions"} message={termsData?.data} />}
      <Copyright_Footer/>
    </div>
  );
}
